import React from "react";
import Navbar from "../components/navigation/Navbar";
import image1 from "../assets/images/dashboard/dashboard-1.png";
import image2 from "../assets/images/dashboard/dashboard-2.png";
import image3 from "../assets/images/dashboard/dashboard-3.png";
import backgroundImage from "../assets/images/bosco-3.jpg";
import backgroundImage2 from "../assets/images/donbosco-2.jpg";
import { Link } from "react-router-dom";

const LandingPage = () => {
  return (
    <div
      className="relative w-full h-auto min-h-screen flex flex-col gap-6 items-center justify-between bg-content bg-cover bg-center "
      // style={{ backgroundImage: `url(${backgroundImage2})` }}
    >
      {/* <div className="absolute bg-black  inset-0 opacity-70 w-screen h-screen"></div> */}
      <div className="flex h-auto min-h-full w-full flex-col gap-3 px-[2%] py-3 transition-all duration-500 ease-in-out md:px-[5%] lg:px-[10%] bg-content relative z-10">
        <Navbar />
        <main
          id="#"
          className="flex-1 flex flex-col items-center justify-center text-text-gen"
        >
          {/* Title */}
          <div className="mt-10 text-center gap-3 mb-7 text-text-1/85">
            <h1 className="!font-playwrite ">
              Salesians
              <span className="text-primary"> PMS </span>
            </h1>
            <p className="px-10 sm:px-32 py-4 text-center">
              Don Bosco (AOS) PMS is a tailored project management platform
              designed exclusively for the Don Bosco non-profit organization.
            </p>
          </div>

          {/* Buttons */}
          <div className=" flex items-center justify-center gap-5">
            <Link className="cancel-rss-btn" to="/dashboard">
              Get Started
            </Link>
            <Link className="add-rss-btn" to="/dashboard">
              Learn More
            </Link>
          </div>

          <div className="pt-5 grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-4  md:gap-4 max-w-[30%] sm:max-w-[90%] min-w-[30%] sm:min-w-[85%] md:min-w-[80%] lg:min-w-[65%] ">
            <div className="h-64 min-w-48 max-w-60 bg-orange-500 border border-orange-500 rounded-xl pb-5 text-orange-500  transform sm:rotate-[8deg]">
              <div className="bg-content h-full w-full rounded-xl flex flex-col items-center justify-center">
                <p>Top Tear Security</p>
                <div className="h-[85%] overflow-hidden p-4">
                  <img src={image1} className="object-cover w-full h-auto " />
                </div>
              </div>
            </div>
            <div className="h-64 min-w-48 max-w-60 bg-primary border border-primary rounded-xl pb-5 text-primary sm:mt-4">
              <div className="bg-content h-full w-full rounded-xl flex flex-col items-center justify-center">
                <p>The Bold Step</p>
                <div className="h-[85%] overflow-hidden p-4">
                  <img src={image2} className="object-cover w-full h-auto " />
                </div>
              </div>
            </div>
            <div className="h-64 min-w-48 max-w-60 bg-green-500 border border-green-500 rounded-xl pb-5 text-green-500  transform sm:rotate-[-8deg]">
              <div className="bg-content h-full w-full rounded-xl flex flex-col items-center justify-center">
                <p>Continue the pressure</p>
                <div className="h-[85%] overflow-hidden p-4">
                  <img src={image3} className="object-cover w-full h-auto " />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default LandingPage;
